import axios from 'axios';

// ============================================================
// CONFIGURAÇÃO HÍBRIDA: Dev (localhost) + Prod (api.fracarostore.com.br)
// ============================================================

const isProd = process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost';

const baseURL = isProd 
  ? 'https://api.fracarostore.com.br'
  : 'http://localhost:3001';

console.log(`🌐 API URL: ${baseURL} (${isProd ? 'PRODUÇÃO' : 'DESENVOLVIMENTO'})`);

const api = axios.create({
  baseURL,
  withCredentials: true, // HttpOnly cookies are automatically sent with requests
});

// ============================================================
// Retry Logic para HTTP 429 (Rate Limit)
// ============================================================
api.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config;
    const requestUrl = config?.url || '';
    const retryExplicitamenteDesativado = Boolean(config?.disableRateLimitRetry);
    const rotaSensivelAutenticacao = [
      '/login',
      '/usuario',
      '/verificacao-email',
      '/enviar-codigo-confirmacao-email',
      '/requisicao-resetar-senha',
      '/verificar-codigo-resetar-senha',
      '/resetar-senha'
    ].some(path => requestUrl.includes(path));

    // Se não for 429 ou já excedeu tentativas, rejeita
    if (error.response?.status !== 429 || !config || retryExplicitamenteDesativado || rotaSensivelAutenticacao) {
      return Promise.reject(error);
    }

    // Inicializa contador de retentativas
    config.retryCount = config.retryCount || 0;
    const maxRetries = 3;

    if (config.retryCount >= maxRetries) {
      return Promise.reject(error);
    }

    config.retryCount++;

    const retryAfterHeader = error.response?.headers?.['retry-after'];
    const retryAfterSeconds = Number(retryAfterHeader);

    // Usa Retry-After quando disponível; senão, fallback para exponential backoff.
    const delayMs = Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
      ? retryAfterSeconds * 1000
      : Math.pow(2, config.retryCount) * 1000;
    console.warn(
      `⚠️ Rate limited (429). Tentativa ${config.retryCount}/${maxRetries} em ${delayMs}ms...`
    );

    await new Promise(resolve => setTimeout(resolve, delayMs));

    return api(config);
  }
);

// Removed localStorage token handling - using HttpOnly cookies instead
// Token is now securely stored in HttpOnly cookie set by server during login

export default api;

